import type { ReactNode } from "react";
import { StickySearchWrapper } from "@/components/search/sticky-search-wrapper";

interface PageHeroWithSearchProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export function PageHeroWithSearch({
  title,
  subtitle,
  children,
}: PageHeroWithSearchProps) {
  return (
    <>
      <section className="py-6 sm:py-8 md:py-12">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight mb-2">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm sm:text-base text-muted-foreground mb-0 max-w-xl mx-auto">
              {subtitle}
            </p>
          )}
        </div>
      </section>
      <StickySearchWrapper>{children}</StickySearchWrapper>
    </>
  );
}
